import { DatasetAggregate } from './datasetItemModel';
import { DatasetItemViewProps } from './datasetItemProps';

export function buildDatasetItemViewProps(item: DatasetAggregate): DatasetItemViewProps {
    return {
        label: item.dataset.name,
        iconUrl: item.plugin.iconUrl ?? '',
    };
}
